export function useToast() {
  return { toast: (_opts: { title?: string; description?: string; variant?: string }) => {} };
}
